import {    
    LISTAR_CONFIGURACION        
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case LISTAR_CONFIGURACION:
            return{
                ...state,
                configuracion: action.payload
            };
        default:
            return state
    }
        
}